import { api } from "@/shared/lib/axios"

export const telegramAuth = async (initData: string) => {
  const { data } = await api.post("/auth/telegram", {
    init_data: initData,
  })

  return data
}